import type { Tracker } from '@archipro-website/tracker';

interface TrackTileMediaProps {
    itemID: number;
    itemType: string;
    itemName: string;
    variant: 'A' | 'B';
}

/**
 * Track the `TileMediaCarouselNext and TileMediaDetailClick` event. Triggers when a user clicks the next button
 * in the carousel, which will show the "View more" tile in variant B record on the 5th tile which variant and do same on Click.
 */
// eslint-disable-next-line import/no-unused-modules
export const trackTileMediaCarouselNext = (
    tracker: Tracker,
    props: TrackTileMediaProps
) => {
    tracker.log('TileMediaCarouselNext', {
        url: new URL(window.location.href),
        label: props.itemName,
        data: {
            content_ids: [`${props.itemType}_${props.itemID}`],
            content_type: props.itemType,
            variant: props.variant,
        },
        targetTracker: ['archiproTracker', 'ga4Tracker'],
    });
};

/**
 * Track the `TileMediaDetailClick` event. Triggers when a user clicks on a tile
 * to go to the detail page.
 */
// eslint-disable-next-line import/no-unused-modules
export const trackTileMediaDetailClick = (
    tracker: Tracker,
    props: TrackTileMediaProps
) => {
    tracker.log('TileMediaDetailClick', {
        url: new URL(window.location.href),
        label: props.itemName,
        data: {
            content_ids: [`${props.itemType}_${props.itemID}`],
            content_type: props.itemType,
            variant: props.variant,
        },
        targetTracker: ['archiproTracker', 'ga4Tracker'],
    });
};
